import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td} from "@chakra-ui/react";
import { TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom,modalAtom } from "../../../context";
import { NewLoader as Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { MdMoreVert as MoreIcon } from "react-icons/md"
import moment from "moment";
import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react'

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function RegistrationReport({ data }:any)  {
const [hide,set_hide] = useState<boolean>(true);
const queryClient = useQueryClient();
const [activeIndex] = useAtom(indexAtom);
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const [selected_examperiod,set_selected_examperiod] = useState<any>('');
const [selected_level,set_selected_level] = useState<null | string>(null);
const [selected_subject, set_selected_subject] = useState<null | string>(null);

const setType = useMemo(() => ['Both', 'Resit', 'Regular'], []);
 



const handleRequest =(level:number | null,period:null|number)=>{
  return level&&period
  
}
 
const {data:allExamPeriod} = useQuery(['exam-period'],{
      queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
      select(data){
       
        return data.data.Data;
      },
    });
  
    const {data:allLevel} = useQuery(['exemption'],{
      queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
      select(data){
        return data.data.Data;
      },
    })

    const { data: allCandidateRegistration, isLoading } = useQuery(
      ['registration-report', selected_examperiod, selected_level,selected_subject],
      {
        queryFn: async () => {
          const params: Record<string, string> = {};
    
          // Ensure at least one filter is applied
          if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
          if (selected_level) params.LevelId = selected_level;
          if (selected_subject) params.ResitPrompt = selected_subject; // Assuming selected_subject is already a string

    
          return await apiCall().get(`Exam/GetAllRegisteredStudent`, { params });
        },
        enabled: !!selected_examperiod || !!selected_level, // Runs only when at least one is selected
        select(data: any) {
          console.log(data, 'data1');
          return data.data.reportItems;
        },
      }
    );
    
    
    

  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(allCandidateRegistration);

  
  // const handleSearch = (e:any)=>{
  //   let val = e.target.value;
  //   set_search(val);
  //   if(val){
  //     let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
  //     if(new_data.length > 0)set_filter_data(new_data)
  //     else set_filter_data(allcandidateRegistration)
  //   }
  //   else set_filter_data(allcandidateRegistration)
  // }
  
  const handleSearch = async (e: any) => {
    let val = e.target.value.trim(); // Remove spaces from input
    set_search(val);
  
    if (val.length > 0) {
      try {
        // API call to fetch filtered data from the server
        const response = await apiCall().get(`Exam/GetAllRegisteredStudent`, {
          params: {
            PageNumber: 1,
            PageSize: 100,
            StudentNo: val, // Send StudentNo or Name to API
          },
        });
  
        console.log("Search API Response:", response.data);
  
        if (response.data?.reportItems.length > 0) {
          set_filter_data(response.data.reportItems);
        } else {
          set_filter_data([]); // No results found
        }
      } catch (error) {
        console.error("Error fetching search results:", error);
        set_filter_data([]); // Handle errors gracefully
      }
    } else {
      set_filter_data(allCandidateRegistration?.reportItems || []);
    }
  };
  
  const handleReload = () => {
  set_search('');
  set_filter_data(allCandidateRegistration); // Reset to full data
  };
  
  

  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  }; 

  // const handleFilter = (e:any) =>{
  //   const value = Number(e?.target?.value || 0);
  //   console.log(value)

  //   if(value || !isNaN(value)){
  //      let data = allcandidateRegistration?.filter((eData:any) => {
  //       console.log(eData.Level,'Level')
  //       return eData.Level.Id == value});
  //     set_filter_data(data && data.length > 0 ?data : allcandidateRegistration)
  //   }
  //   else{
  //     set_filter_data(allcandidateRegistration) 
  //   }

  // } 
  
  const handleFilter = (e: any, type: string) => {
    const value = type === 'level' ? Number(e || 0) : e;
  
    if (type === 'level') {
      if (value || !isNaN(value)) {
        let filteredData = allCandidateRegistration?.filter(
          (eData: any) => eData.LevelId == value // Ensure proper filtering by LevelId
        );
  
        // Further filter by selected exam period if applicable
        if (selected_examperiod) {
          filteredData = filteredData?.filter(
            (eData: any) => eData.ExamPeriodId == selected_examperiod
          );
        }
  
        // Set filtered data, ensuring empty results don't reset to full data
        set_filter_data(filteredData && filteredData.length > 0 ? filteredData : []);
        set_selected_level(value);
      }
    } else if (type === 'period') {
      if (value) {
        set_selected_examperiod(value);
        let filteredData = allCandidateRegistration?.filter(
          (eData: any) => eData.ExamPeriodId == value
        );
  
        // Ensure empty results don't reset to full data
        set_filter_data(filteredData && filteredData.length > 0 ? filteredData : []);
      }
    } else {
      let filteredData = allCandidateRegistration;
  
      if (selected_examperiod) {
        filteredData = filteredData?.filter(
          (eData: any) => eData.ExamPeriodId == selected_examperiod
        );
      }
  
      set_filter_data(filteredData);
    }
  };
  
  
  const handleChangePeriod = (value: any) => {
    if (value) {
      set_selected_examperiod(value?.Id); // Store selected period
      let check: any = allCandidateRegistration.filter((e: any) => e.ExamPeriod == value.ExamName);
  
      // If level is also selected, filter by level
      if (selected_level) {
        check = check?.filter((e: any) => e.Level?.Id == selected_level);
      }
  
      set_filter_data(check && check.length > 0 ? check : allCandidateRegistration);
    }
  };
  
  

  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationKey: [selected_examperiod, selected_level],
    mutationFn: async () => {
      let url = `/ExamReport/downloadAllRegisteredStudentReport`;
  
      const params = new URLSearchParams();
      if (selected_examperiod) params.append("ExamPeriodId", selected_examperiod);
      if (selected_level) params.append("LevelId", selected_level);
      if (selected_subject) params.append("ResitPrompt", selected_subject);

  
      // If any parameters were added, append them to the URL
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
  
      const method = "POST", body = {}, config = {}, download = true;
      return await downloadApi(url, method, body, config, download);
    },
    onSuccess: async (data: any) => {
      // Initialize the download
      console.log(data, 'download data');
      const file = data;
  
      if (file) {
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Registered Candidate-List.xlsx");
        document.body.appendChild(link);
        link.click();
        console.log(file, 'data');
        set_notification({
          type: 'success',
          message: data?.data?.Message || 'Registered Candidate List downloaded successfully'
        });
        set_Nopen(true);
      } else {
        set_notification({
          type: 'error',
          message: 'Oops! An error occurred while trying to download the file'
        });
        set_Nopen(true);
      }
    },
    onError(error: any) {
      set_notification({ 
        type: 'error',
        message: error?.data?.Message || 'An error occurred'
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    }
  });
  
    
  
    useEffect(()=>{
      set_filter_data(allCandidateRegistration)
    },[allCandidateRegistration])
  return (
    <>
      <Box>
      <TopDisplay label="Registered Candidate List" button_array={[
        
          <Button disabled={isDownloading} type="submit" color="var(--white-color)" 
          bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
          onClick={()=>handleDownload()} 
        > {isDownloading?"DownLoading":'Download Registered Candidate List'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
          <span
            style={{
              position: 'absolute',
              zIndex: '1',
              right: '10px',
              cursor: 'pointer',
              top: '12px'
            }}
            onClick={handleReload} 
          >
            <ReloadIcon />
          </span>
          </InputGroup>

          <Select 
              placeholder='Exam Period' 
              width="140px" 
              bg="var(--white-color)" 
              borderColor="var(--dark-green-color)" 
              onChange={(e: any) => set_selected_examperiod(e.target.value)}
              name="ExamPeriodId"
              >
              <option value="">All Exam Periods</option> 

              {allExamPeriod && allExamPeriod.length > 0 ? 
                allExamPeriod.map((eType: any) => (
                  <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>
                )) 
              : ''}
            </Select>

          {/* <ReactSelect 
              name="ExamName"
              onChange={handleChangePeriod}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e:any)=> ({...e,['label']:e.ExamName,['value']:e.Id}))} /> */}
              
              <Select placeholder="Level" width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)"onChange={(e:any)=>handleFilter(e.target.value,'level')} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
             <Select placeholder='Re-Sit Type' width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_subject(e.target.value)}
                  name="SitType"
                >
                  <>{setType.map((eType:any) => <option key={eType} value={eType}>{eType}</option>)}</>
                </Select>
          </Flex>
      
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Registered Candidate</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
        {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
          <Table size="sm" variant="striped" sx={{ tableLayout: 'auto', width: '100%' }}>
      <Thead>
      <Tr>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Student Number</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>First Name</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Last Names</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Gender</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Phone No</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Email</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Subject</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>study center</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Level</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Exam Diet</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Address</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Amount</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Reg.Date</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Date</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Resit</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Deffered</Th> */}
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Status</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '50px' }}></Th>
      </Tr>
    </Thead>
    <Tbody>
      {currentItems.map((eUpgradeScore: any, index: number) => (
        <ROWSTYLE key={eUpgradeScore.Id}>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.StudentNo || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.FirstName || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2, whiteSpace: 'normal' }}>{eUpgradeScore.LastName || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Gender || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.PhoneNumber || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Email || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(', ')?.slice(0, 35) || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.StudyCenter?.Name || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Level?.ExemptionName || ''}</Td>
          {/* <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Level?.ExamDiet || ''}</Td> */}
          <Td title={eUpgradeScore.Address} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>
            {eUpgradeScore.Address || 'N/A'}
          </Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.Level?.ExamAmount ?? 'N/A'}
            </Td>
        <Td sx={{ ...DataStyle, p: 2 }}>
         {moment.utc(eUpgradeScore.RegistrationDate).local().format("YYYY-MM-DD hh:mm:ss A")}
        </Td>

          {/* <Td sx={{ ...DataStyle, p: 2 }}>{moment(eUpgradeScore.ExamDateTime).format("yyyy-MM-DD")}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsResit ? 'Yes' : 'No'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsDeffered ? 'Yes' : 'No'}</Td> */}
          <Td sx={{ ...DataStyle, p: 2 }} minW="60px" w="50px" h="50px">
            <Option
              index={index}
              candidate={{ ...eUpgradeScore, ExamPeriodId: allExamPeriod.find((eExam: any) => eExam.ExamName === eUpgradeScore.ExamPeriod)?.Id }}
              levels={allLevel}
              periods={allExamPeriod}
            />
          </Td>
        </ROWSTYLE>
     ))}
    </Tbody>
  </Table>
</TableContainer>
: 'No Registered Candidate'}

      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
    <Loader show={isLoading} />

</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  useEffect(()=>{
    set_new_level(candidate?.Level?.Id)
  },[])

 

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

 
  
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>
            View Details
          </GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Grid templateColumns="1fr"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Student No</Text>
        <Text fontWeight="500">{props.candidate?.StudentNo}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">First Name</Text>
        <Text fontWeight="500">
          {props.candidate.FirstName}
        </Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Last Name</Text>
        <Text fontWeight="500">{props.candidate?.LastName}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone</Text>
        <Text fontWeight="500">{props.candidate?.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email</Text>
        <Text fontWeight="500">{props.candidate?.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level?.ExemptionName }</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Amount</Text>
        <Text fontWeight="500">{props.candidate?.Amount}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate?.Address}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Registration Date</Text>
        <Text fontWeight="500">{moment(props.candidate?.RegistrationDate).format("yyyy-MM-DD")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Exam Date</Text>
        <Text fontWeight="500">{moment(props.candidate?.ExamDateTime).format("yyyy-MM-DD")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Resit</Text>
        <Text fontWeight="500">{props.candidate?.IsResit ? 'Yes' : 'No'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Subjects</Text>
        <Text fontWeight="500">
          {props.candidate.Subjects.map((eSubject: any) => eSubject.ExamSubject.Name).join(', ')}
        </Text>
      </GridItem>
      
    </Grid>
  </Flex>
  )}
